<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19e19CF/tc-custom/9781423638087.jpg?1718282660248" alt="This image is the cover for the book I Love Ramen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">I Love Ramen
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Use your noodle with these</b> <b>75 recipes for turning a dorm-room staple into scrumptious meals!</b></p><p>If necessity is the mother of invention, a college student’s food budget certainly led to the invention of some delicious ways with one of the least expensive, most convenient packaged foods of all time. This cookbook, from a ramen maven who’s appeared on the Food Network, is filled with taste-tempting photos and shows that the humble block of ramen noodles can be magically transformed into delicious main dishes as well as sides, soups and salads. There are even a couple of desserts based on the ever-popular ramen noodle! </p><p>Recipes include: Beef &amp; Broccoli Stir-fry * Crab Lo Mein * Baked Stuffed Tomatoes * Fiesta Chicken * Cheesy Bacon Noodles * Ramen Rolled Steak * Tangerine Chicken Salad * Thin Mint on a Stick * and many more</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Toni Patrick
      </h2>
      
      <p class="authorDescription body article">Toni Patrick is also the author of 101 Things to Do with Ramen Noodles, 101 Things to Do with Mac & Cheese, and 101 Things to Do with Canned Biscuits. She lives in Colorado.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?05dddd79